// extracted by css-extract-rspack-plugin
export default {"DataBucketList":"O0Rci","DataBucketListItemTitle":"kYcSt","DataBucketListItemDescription":"wxstw","DataBucketListItemIcon":"ZHy7a","DataBucketListItemContainer":"K0TaK"};